export enum ErknmAnalyticsActionsEnum {
  ERKNM_ANALYTICS_INIT_PAGE = 'ERKNM_ANALYTICS_INIT_PAGE',
  ERKNM_ANALYTICS_GET_DATA = 'ERKNM_ANALYTICS_GET_DATA',
  ERKNM_ANALYTICS_GET_DATA_NEXT = 'ERKNM_ANALYTICS_GET_DATA_NEXT',
  ERKNM_ANALYTICS_SET_DATA = 'ERKNM_ANALYTICS_SET_DATA',
  ERKNM_ANALYTICS_SET_FILTER = 'ERKNM_ANALYTICS_SET_FILTER',
  ERKNM_ANALYTICS_SET_TABLE_COLUMNS = 'ERKNM_ANALYTICS_SET_TABLE_COLUMNS',
  ERKNM_ANALYTICS_GET_ADDITIONAL_COLUMNS = 'ERKNM_ANALYTICS_GET_ADDITIONAL_COLUMNS',
  ERKNM_ANALYTICS_EXPORT = 'ERKNM_ANALYTICS_EXPORT',
  ERKNM_ANALYTICS_EXPORT_KNM_LIST = 'ERKNM_ANALYTICS_EXPORT_KNM_LIST',
  ERKNM_ANALYTICS_GET_KNM_LIST = 'ERKNM_ANALYTICS_GET_KNM_LIST',
  ERKNM_ANALYTICS_GET_KNM_LIST_NEXT_PAGE = 'ERKNM_ANALYTICS_GET_KNM_LIST_NEXT_PAGE',
  ERKNM_ANALYTICS_SET_KNM_LIST = 'ERKNM_ANALYTICS_SET_KNM_LIST',
  ERKNM_ANALYTICS_SET_ORDER = 'ERKNM_ANALYTICS_SET_ORDER',
}
